import { ContactResearchCard } from "../components/cards/ContactResearchCard";
import { RescoreCard } from "../components/cards/RescoreCard";
import { PersonalizationCard } from "../components/cards/PersonalizationCard";

export function Dashboard() {
  return (
    <>
      <ContactResearchCard />
      <RescoreCard />
      <PersonalizationCard />
    </>
  );
}
